'use client';

import { useSuspenseQuery } from '@apollo/client/react';
import { FC, PropsWithChildren, useMemo } from 'react';

import { User } from '@/.gql/graphql';
import { GET_ME_SUBSCRIPTIONS } from '@/.graphql';

import { createCustomContext } from './context';

interface ISubscriptionsForMeProps {
  mySubscriptions: Array<User>;
}

const [SubscriptionsForMeContext, useSubscriptionsForMeContext] =
  createCustomContext<ISubscriptionsForMeProps>({
    name: 'SubscriptionsContext',
    strict: false,
  });

export { useSubscriptionsForMeContext };

export const SubscriptionsForMeProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  const { data } = useSuspenseQuery(GET_ME_SUBSCRIPTIONS);

  const mySubscriptions = useMemo(() => data?.getMeSubscriptions ?? [], [data]);

  const contextValue = useMemo(() => ({ mySubscriptions }), [mySubscriptions]);

  return (
    <SubscriptionsForMeContext value={contextValue}>
      {children}
    </SubscriptionsForMeContext>
  );
};
